import _Tooltip from "antd/es/tooltip";
import _Tag from "antd/es/tag";
var _excluded = ["type", "dot", "isRound", "closable", "ellipsis", "maxWidth", "width", "style", "className", "closeIcon", "children"],
    _excluded2 = ["ellipsis", "maxWidth", "width", "style", "className", "checked", "children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useRef, useEffect, useState } from 'react';
import CheckableTag from 'antd/es/tag/CheckableTag';
import SLSymbolIcon from '../SLSymbolIcon';
import cs from 'classnames';
import './index.less';
var classPrefix = 'sl-tag';

/**
 * import { SLTag } from '@yy/sl-admin-components'
 */
var SLTag = function SLTag(_ref) {
  var _cs;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'normal' : _ref$type,
      dot = _ref.dot,
      isRound = _ref.isRound,
      closable = _ref.closable,
      _ref$ellipsis = _ref.ellipsis,
      ellipsis = _ref$ellipsis === void 0 ? true : _ref$ellipsis,
      maxWidth = _ref.maxWidth,
      width = _ref.width,
      style = _ref.style,
      className = _ref.className,
      _ref$closeIcon = _ref.closeIcon,
      closeIcon = _ref$closeIcon === void 0 ? /*#__PURE__*/React.createElement(SLSymbolIcon, {
    icon: "iconclose-small"
  }) : _ref$closeIcon,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var tagRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasTooltip = _useState2[0],
      setHasTooltip = _useState2[1];

  useEffect(function () {
    if (tagRef.current && children && ellipsis) {
      setHasTooltip(tagRef.current.offsetWidth < tagRef.current.scrollWidth); // 处理单行省略
    }
  }, [tagRef, children, ellipsis]);
  return /*#__PURE__*/React.createElement(_Tooltip, {
    trigger: hasTooltip ? 'hover' : 'contextMenu',
    title: children
  }, /*#__PURE__*/React.createElement(_Tag, _extends({
    className: cs(className, classPrefix, "".concat(classPrefix, "-").concat(type), (_cs = {}, _defineProperty(_cs, "".concat(classPrefix, "-dot"), dot !== null && dot !== void 0 ? dot : !closable ? true : false), _defineProperty(_cs, "".concat(classPrefix, "-round"), isRound !== null && isRound !== void 0 ? isRound : !closable ? true : false), _defineProperty(_cs, "".concat(classPrefix, "-closable"), closable), _cs)),
    style: _objectSpread({
      maxWidth: maxWidth,
      width: width
    }, style),
    closable: closable,
    closeIcon: closeIcon
  }, rest), /*#__PURE__*/React.createElement("span", {
    ref: tagRef,
    className: "".concat(classPrefix, "-content")
  }, children)));
};

export var SLCheckableTag = function SLCheckableTag(_ref2) {
  var _cs2;

  var _ref2$ellipsis = _ref2.ellipsis,
      ellipsis = _ref2$ellipsis === void 0 ? true : _ref2$ellipsis,
      maxWidth = _ref2.maxWidth,
      width = _ref2.width,
      style = _ref2.style,
      className = _ref2.className,
      checked = _ref2.checked,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var tagRef = useRef(null);

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showTooltip = _useState4[0],
      setShowTooltip = _useState4[1];

  useEffect(function () {
    if (tagRef.current && children && ellipsis) {
      setShowTooltip(tagRef.current.offsetWidth < tagRef.current.scrollWidth); // 处理单行省略
    }
  }, [tagRef, children, ellipsis]);
  return /*#__PURE__*/React.createElement(_Tooltip, {
    trigger: showTooltip ? 'hover' : 'contextMenu',
    title: children
  }, /*#__PURE__*/React.createElement(CheckableTag, _extends({
    className: cs(className, classPrefix, (_cs2 = {}, _defineProperty(_cs2, "".concat(classPrefix, "-normal"), !checked), _defineProperty(_cs2, "".concat(classPrefix, "-info"), checked), _cs2)),
    style: _objectSpread({
      maxWidth: maxWidth,
      width: width
    }, style),
    checked: checked
  }, rest), /*#__PURE__*/React.createElement("span", {
    ref: tagRef,
    className: "".concat(classPrefix, "-content")
  }, children)));
};
SLTag.CheckableTag = SLCheckableTag;
export default SLTag;